import React from 'react'
import styled from 'styled-components'

const Tag = styled.span<{color?: string}>`
  background-color: ${({color}) => color || 'gray'};
  color: #303030;
  padding: .3rem .5rem;
  border-radius: .4rem;
  font-size: 12px;
  display: inline-flex;
  align-items: center;
`

const TagComponent: React.FC<{name: string, color?: string}> = ({name, color}) => {
  return (
    <Tag color={color}>
      {name}
    </Tag>
  )
}

export default TagComponent